export class ZebraBrowserPrint {
  static getLocalDevices: (
    finishedCallBack: (res: { printer: ZebraPrinter[] }) => any,
    errorCallBack?: (err: any) => any
  ) => void;

  static getDefaultDevice: (
    type: 'printer',
    finishedCallBack: (res: ZebraPrinter) => any,
    errorCallBack?: (err: any) => any
  ) => void;
}

export abstract class ZebraDevice {
  sendErrorCallback: (err: any) => any;

  abstract send(
    dataToSend: string,
    finishedCallBack: (data: any) => void,
    errorCallback: (err: any) => void
  ): void;
}

export abstract class ZebraPrinter extends ZebraDevice {
  connection: 'usb' | 'network';
  // deviceType: 'printer';
  // manufacturer: 'Zebra Technologies';
  name: string;
  uid: string;
}
